<template>
  <t-prefix>
    <label :for="`bulk_checkbox_${entry.id}`" class="sr-only">Select record for bulk action</label>
    <input
      ref="checkbox" type="checkbox" v-on:input="selectEntry()" :checked="isSelectedEntry" :id="`bulk_checkbox_${entry.id}`">
  </t-prefix>
</template>


<script lang="ts">
  import Vue from "vue";
  import SubmissionDecorator from "../../formability/analyst_dashboard/models/submissionDecorator";
  import bulkActionMixin from "../mixins/bulkActionMixin";
  import ObjectModelFakeEntry from "../models/objectModelEntries/objectModelFakeEntry";
  import ObjectModelEntry from "../models/objectModelEntries/objectModelEntry";

  export default Vue.extend({
    mixins: [bulkActionMixin],
    props: {
      entry: {
        required: true,
        type:  Object as () => SubmissionDecorator |  ObjectModelFakeEntry | ObjectModelEntry
      }
    },
    computed: {
      isSelectedEntry() {
        return this.selectedEntries.filter(x => x.id === this.entry.id).length > 0
      },

    },
    methods: {
      selectEntry() {
        //@ts-ignore
        if (event.target.checked) {
          this.$store.commit("bulkActionStore/selectEntry", this.entry)
        } else {
          this.$store.commit("bulkActionStore/removeEntryFromSelected", this.entry)
        }
      }
    },
    mounted() {
      if (this.allFilteredEntriesSelected) {
        this.$store.commit("bulkActionStore/selectEntry", this.entry)
      }
      this.$store.commit("bulkActionStore/selectAllSeenEntries", false);
    },
    watch: {
      allFilteredEntriesSelected: function (val) {
        if (val) {
          this.$store.commit("bulkActionStore/selectEntry", this.entry)
        }
      },
      allSeenEntriesSelected: function (val) {
        if (val && !this.isSelectedEntry) {
          this.$store.commit("bulkActionStore/selectEntry", this.entry)
        }
      },
    },
  })
</script>